import { Skeleton } from "@mui/material";
import type * as React from "react";

import { ArticleInfoContainer, BottomContainer, RightContainer, RootContainer, TopContainer } from "./SmallWishlistItem.styles";

interface SmallWishlistItemSkeletonProps {
    showBorderBottom: boolean;
}

export const SmallWishlistItemSkeleton: React.FunctionComponent<SmallWishlistItemSkeletonProps> = ({ showBorderBottom }) => {
    return (
        <RootContainer showBorderBottom={showBorderBottom}>
            <TopContainer>
                <ArticleInfoContainer>
                    <Skeleton height={24} width={150} />

                    <Skeleton height={18} width={80} />

                    <Skeleton height={20} width={170} />

                    <Skeleton height={18} width={60} />
                </ArticleInfoContainer>
            </TopContainer>

            <BottomContainer>
                <Skeleton height={24} width={50} />

                <RightContainer>
                    <Skeleton height={24} width={120} />
                </RightContainer>
            </BottomContainer>
        </RootContainer>
    );
};
